<mat-form-field
    appearance="outline"
    class="w-24">
    <div class="flex flex-row">
        <div
            class="dot absolute"
            [style.background]="colorControl().value"></div>
        <mat-select [formControl]="colorControl()">
            @for (color of colors; track color) {
                <mat-option [value]="color">
                    <div
                        class="dot"
                        [style.background]="color"></div>
                </mat-option>
            }
        </mat-select>
    </div>
</mat-form-field>
